// extracted by mini-css-extract-plugin
export default {"image_proxy_flag":"kyberconfig_image_proxy_flag__TbUuo"};